function buildSampleUpdates(samples, selectedIds) {
  const selectedSet = new Set(selectedIds.map(String));
  const updates = {};

  samples.forEach(({ variantId }) => {
    const id = String(variantId);
    updates[id] = selectedSet.has(id) ? 1 : 0;
  });

  return updates;
}

async function updateCart(updates) {
  // console.log('Updating cart with updates:', updates);
  const response = await fetch(
    `${window.themeVariables.routes.cartUpdateUrl}.js`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ updates }),
    }
  );

  if (!response.ok) return null;
  return response.json();
}

function refreshCart(cart) {
  document.documentElement.dispatchEvent(
    new CustomEvent("cart:refresh", {
      bubbles: true,
      detail: {
        cart,
        replacementDelay: 600,
      },
    })
  );

  document.documentElement.dispatchEvent(
    new CustomEvent("cart:updated", {
      bubbles: true,
      detail: { cart },
    })
  );
}

document.addEventListener("sample-picker:change", async (event) => {
  const { selectedIds = [] } = event.detail || {};

  const config = window.samplePickerConfig;
  if (!config?.samples?.length) return;

  const updates = buildSampleUpdates(config.samples, selectedIds);

  const cart = await updateCart(updates);
  if (!cart) return;

  refreshCart(cart);
});

// REMOVE SAMPLES IF NO REAL PRODUCTS LEFT IN CART LOGIC

// ---- SAMPLE CLEANER HELPERS ----

function getSampleVariantSet() {
  const config = window.samplePickerConfig;
  if (!config?.samples?.length) return null;

  return new Set(config.samples.map((s) => String(s.variantId)));
}

function getGiftVariantSet() {
  const giftVariantSet = new Set();

  // GiftLogic gift variants
  if (Array.isArray(window.giftLevels)) {
    window.giftLevels.forEach((lvl) => {
      if (lvl.giftId) giftVariantSet.add(String(lvl.giftId));
    });
  }

  // buyXgetY gift variants
  if (Array.isArray(window.xyGiftLogic)) {
    window.xyGiftLogic.forEach((rule) => {
      if (rule.yProduct?.variantID) {
        giftVariantSet.add(String(rule.yProduct.variantID));
      }
    });
  }

  return giftVariantSet;
}

function scanCartForSamplesAndRealProducts(cartItems, sampleVariantSet, giftVariantSet) {
  let hasSample = false;
  let hasRealProduct = false;

  cartItems.forEach((item) => {
    const id = String(item.variant_id);

    if (sampleVariantSet.has(id)) {
      hasSample = true;
      return; 
    }

    // detecting if cart has any real products (NOT sample AND NOT gift)
    if (!giftVariantSet.has(id)) {
      hasRealProduct = true;
    }
  });

  return { hasSample, hasRealProduct };
}

function buildSampleRemovalUpdates(cartItems, sampleVariantSet) {
  const updates = {};

  cartItems.forEach((item) => {
    const id = String(item.variant_id);
    if (sampleVariantSet.has(id)) {
      updates[id] = 0;
    }
  });
  return updates;
}

// get sample updates
function getSampleCleanupUpdates(cartItems = []) {
  if (!cartItems.length) return {};

  const sampleVariantSet = getSampleVariantSet();
  if (!sampleVariantSet) return {};

  const giftVariantSet = getGiftVariantSet();

  const { hasSample, hasRealProduct } =
    scanCartForSamplesAndRealProducts(
      cartItems,
      sampleVariantSet,
      giftVariantSet
    );
  if (!hasSample || hasRealProduct) return {};

  return buildSampleRemovalUpdates(cartItems, sampleVariantSet);
}
